import { API } from '@shared/types/api';
import {
  CardPaginationCardFilter,
  CardPaginationDateFilter,
  CardPaginationQuery,
  CardPaginationTagFilter,
  CardPaginationUserFilter,
} from './types';

export const defaultOrder: API.ListCardsOrder = { orderBy: 'createdAt', orderDirection: 'DESC' };

export function toKey(query: CardPaginationQuery): string {
  function replacer(this: any, key: string, value: any): any {
    return this.__typename === 'CardFieldStringTag' && key === 'archivedAt' ? undefined : value;
  }
  return JSON.stringify(query, replacer);
}

export function getQueryRelationFilters(query: CardPaginationQuery): API.CardRelationFilter[] {
  const tagFilters =
    query.filters
      ?.filter((f): f is CardPaginationTagFilter => f.type === 'tag')
      .map<API.CardRelationFilter>(f => ({
        type: 'tags',
        mustHaveAllIds: f.mustHaveAll?.map(t => t.id),
        mustHaveAnyIds: f.mustHaveAny?.map(t => t.id),
        mustNotHaveAnyIds: f.mustNotHaveAny?.map(t => t.id),
      })) ?? [];

  const cardFilters =
    query.filters
      ?.filter((f): f is CardPaginationCardFilter => f.type === 'card')
      .map<API.CardRelationFilter>(f => ({
        type: 'relatedCards',
        mustHaveAllIds: f.mustHaveAll?.map(t => t.cardId),
        mustHaveAnyIds: f.mustHaveAny?.map(t => t.cardId),
        mustNotHaveAnyIds: f.mustNotHaveAny?.map(t => t.cardId),
      })) ?? [];

  return [...tagFilters, ...cardFilters];
}

export function getQueryLegacyRelationFilters(
  query: CardPaginationQuery,
): API.LegacyCardRelationFilter[] {
  const assigneeFilters =
    query.filters
      ?.filter((f): f is CardPaginationUserFilter => f.type === 'user')
      .map<API.LegacyCardRelationFilter>(f => ({
        type: 'assignees',
        mustHaveAllIds: f.mustHaveAllIds,
        mustHaveAnyIds: f.mustHaveAnyIds,
        mustNotHaveAnyIds: f.mustNotHaveAnyIds,
      })) ?? [];

  return assigneeFilters;
}

export function getQueryStartDateBefore(query: CardPaginationQuery): string | undefined {
  return query.filters?.find((f): f is CardPaginationDateFilter => f.type === 'startDate')?.before;
}

export function getQueryStartDateAfter(query: CardPaginationQuery): string | undefined {
  return query.filters?.find((f): f is CardPaginationDateFilter => f.type === 'startDate')?.after;
}

export function getQueryOrder(query: CardPaginationQuery): API.ListCardsOrder[] {
  if (!query.order) {
    return [defaultOrder];
  }
  if (query.order.some(order => order.orderBy === defaultOrder.orderBy)) {
    return query.order;
  }
  return [...query.order, defaultOrder];
}
